(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ledge-brands-index"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.ledge-brands-index');

    sections.forEach((section) => {
      if (section.dataset.filterInit === '1') return;
      section.dataset.filterInit = '1';

      const pills = section.querySelectorAll('.ledge-brands-index__pill');
      const cards = section.querySelectorAll('.ledge-brands-index__card');

      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          pills.forEach((p) => p.classList.remove('is-active'));
          pill.classList.add('is-active');

          const filter = pill.dataset.filter;

          cards.forEach((card) => {
            const categories = (card.dataset.category || '').split(/\s+/);
            const matches = filter === 'all' || categories.includes(filter);
            if (!matches && !card.classList.contains('is-hidden')) {
              card.classList.add('is-fading');
            }
          });

          setTimeout(() => {
            cards.forEach((card) => {
              const categories = (card.dataset.category || '').split(/\s+/);
              const matches = filter === 'all' || categories.includes(filter);
              if (!matches) {
                card.classList.add('is-hidden');
                card.classList.remove('is-fading');
              } else if (card.classList.contains('is-hidden')) {
                card.classList.add('is-fading');
                card.classList.remove('is-hidden');
                card.offsetHeight;
                card.classList.remove('is-fading');
              }
            });
          }, 300);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ledge-main-product"]) return;
  try {
    
  /*
   * LEDGE PDP mobile carousel dots.
   * The CSS in ledge-custom.css turns `.media-gallery__grid` into a
   * horizontal scroll-snap carousel below 750 px. This script appends a
   * dot indicator for each media item, keeps the active dot in sync
   * with the scroll position, and wires up click-to-jump. Dots are
   * hidden on desktop via CSS.
   */
  (function () {
    var galleries = document.querySelectorAll('.product-information__media media-gallery');

    galleries.forEach(function (gallery) {
      if (gallery.dataset.ledgeDotsInit === '1') return;
      gallery.dataset.ledgeDotsInit = '1';

      var grid = gallery.querySelector('.media-gallery__grid, [data-testid="media-gallery-grid"]');
      if (!grid) return;

      var tiles = grid.querySelectorAll('.product-media-container');
      if (tiles.length < 2) return;

      var dots = document.createElement('div');
      dots.className = 'ledge-pdp-dots';
      dots.setAttribute('role', 'tablist');
      dots.setAttribute('aria-label', 'Product image navigation');

      for (var i = 0; i < tiles.length; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ledge-pdp-dot' + (index === 0 ? ' is-active' : '');
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Go to image ' + (index + 1));
          dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
          dot.addEventListener('click', function () {
            tiles[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
          dots.appendChild(dot);
        })(i);
      }

      grid.insertAdjacentElement('afterend', dots);

      var dotEls = dots.querySelectorAll('.ledge-pdp-dot');
      var ticking = false;
      function update() {
        var w = grid.clientWidth || 1;
        var idx = Math.round(grid.scrollLeft / w);
        if (idx < 0) idx = 0;
        if (idx >= dotEls.length) idx = dotEls.length - 1;
        dotEls.forEach(function (d, i) {
          var active = i === idx;
          d.classList.toggle('is-active', active);
          d.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        ticking = false;
      }
      grid.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
